
/**
 * Module dependencies.
 */

import { truncateString } from 'src/core/utils/strings';
import { useLocalizedRoute } from 'src/core/utils/routes';
import Card from './card';
import React, { ReactElement } from 'react';
import useSearchTranslations from 'src/hooks/use-search-translations';

/**
 * `MagazineCard` component.
 */

const MagazineCard = (props): ReactElement => {
  const {
    image_url, // eslint-disable-line id-match
    ...rest
  } = props;

  const { getTranslations } = useSearchTranslations();
  const routeResolver = useLocalizedRoute();
  const { lead, slug, title } = getTranslations(rest);

  return (
    <Card
      description={truncateString(lead, 50)}
      href={routeResolver('storytilingDetails', { slug })}
      imageUrl={image_url}
      title={title}
    />
  );
};

/**
 * Export `MagazineCard` component.
 */

export default MagazineCard;
